import React, { useEffect, useState, useContext, useRef } from 'react'
import PageHeader from '../../components/pageHeader/PageHeader';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import styled from "styled-components";   
import {getAllEstadosToPrestamoAPI, getAllTipoSolicitudPrestamoAPI, getListaGestionSolicitudesPrestamoAPI, exportarPrestamosAdelantosAPI,
    descargarDocumentosSustentoZipAPI,
    getAllEstadosEmpleadoToPrestamoAPI, getAllNivelesToPrestamoAPI,
    getAllCargosToPrestamoAPI, getAllSedesToPrestamoAPI, getAllDepartamentosToPrestamoAPI,
    getAllEnviadoAPlanillaToPrestamoAPI,
    getAllTipoMotivosPrestamoAPI,
    enviarAPlanillaBatchAPI
} from '../../consumers/backendApisUrls';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { useGenerarDescargarEliminarArchivo } from '../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo';
import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData
    , usuarioLogueadoTieneAlgunoDeLosSiguientesRoles
    } from "../../helper/utils";
import SolicitarPrestamo from "./modales/SolicitarPrestamo";
import LineamientosPrestamo from './modales/LineamientosPrestamo';
import TablePrestamosYAdelantos from './TablePrestamosYAdelantos';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { AuthContext } from '../../hooks/context/authContext';
import { ROLES } from '../../constants/hardCodedConstants';


const INIT_KEYS = {
    IdsEstadoEmpleado : "IdsEstadoEmpleado",
    IdsCargosPrestamo : "IdsCargosPrestamo",
    IdsSedesPrestamo : "IdsSedesPrestamo",
    IdsDepartamentosPrestamo : "IdsDepartamentosPrestamo",
    IdsTipoSolicitudPrestamo : "IdsTipoSolicitudPrestamo",
    IdsEstadoProceso: "IdsEstadoProceso",
    IdsNivelesPrestamo : "IdsNivelesPrestamo",
    IdsEnviadoAPlanilla : "IdsEnviadoAPlanilla",
    IdsMotivosPrestamo : "IdsMotivosPrestamo"
}

const GestionPrestamosYAdelantos = () => {
    const { state } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [allFilters, setAllFilters] = useState([]);
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [executeGet] = useGetRequest();
    const [showModalCrearSolicitudPrestamo, setShowModalCrearSolicitudPrestamo] = useState(false);
    const [showLineamientos, setShowLineamientos] = useState(false);
    const [managePostRequest] = useManagePostRequest();
    const [generarDescargarEliminarArchivo] = useGenerarDescargarEliminarArchivo();
    const [rolGestionDePrestamos, setRolGestionDePrestamos] = useState();
    const [rolLiderEquipo, setRolLiderEquipo] = useState();
    const [rolDirector, setRolDirector] = useState();
    const [selectedIds, setSelectedIds] = useState(new Set());
    const selectAllRef = useRef(null);

    const initialPromises = () => [
        executeGet(getAllEstadosEmpleadoToPrestamoAPI()),
        executeGet(getAllCargosToPrestamoAPI()),
        executeGet(getAllSedesToPrestamoAPI()),
        executeGet(getAllDepartamentosToPrestamoAPI()),
        executeGet(getAllTipoSolicitudPrestamoAPI()),
        executeGet(getAllEstadosToPrestamoAPI()),
        executeGet(getAllNivelesToPrestamoAPI()),
        executeGet(getAllEnviadoAPlanillaToPrestamoAPI()),
        executeGet(getAllTipoMotivosPrestamoAPI())
    ]

    useEffect(() => {
        init();
    }, [])
    
    const init = async () => {
        setIsLoading(true);
        setRolGestionDePrestamos(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.GestionPrestamosYAdelantos.id]));
        setRolLiderEquipo(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.LiderEquipo.id]));
        setRolDirector(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.DirectorDeColegio.id]));
        await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
        await manageSearch();
        setIsLoading(false);
    }

    const manageSearch = async () => {
        try{
            setIsLoading(true);
            const api = getListaGestionSolicitudesPrestamoAPI();
            const payload = getPayload();
            await managePostRequest(api, payload, successManageSearchCallback);
        }catch(error){
            console.error(error);
        }finally{
            setIsLoading(false);
        }                
    }
    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }
    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
    }
    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const toggleCrearSolicitudPrestamo = () => {
        setShowModalCrearSolicitudPrestamo(!showModalCrearSolicitudPrestamo);
    };

    const manageSearchProxy = (response) => {
        manageSearch();
    }

    const handleDownloadExcel = async () => {
        const api = exportarPrestamosAdelantosAPI();
        const payload = getPayload();
        await generarDescargarEliminarArchivo(api, payload);
    }

    const handleDownloadZip = async () => {
        const api = descargarDocumentosSustentoZipAPI();
        const payload = getPayload();
        await generarDescargarEliminarArchivo(api, payload);
    }

    const handleEnviarAPlanillaBatch = async () => {
        const api = enviarAPlanillaBatchAPI();
        const payload = {
            Ids: Array.from(selectedIds),
            EnviadoAPlanilla: true,
            IdUsuario: state?.user?.IdUsuario || state?.user?.id
        };
        await managePostRequest(api, payload, ({data}) => {
            setSelectedIds(new Set());
            manageSearch();
        });
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        formValues.ExtraData && jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])
    

    return (
        <>
        {showModalCrearSolicitudPrestamo && 
        <div className="modal-contactanos modal-response-ficha-background">	
            <SolicitarPrestamo showModal={toggleCrearSolicitudPrestamo} 
                refreshPage={manageSearch} fromAdminPage={true} esGestorPrestamos={rolGestionDePrestamos} />
        </div>
        }
        {showLineamientos && (
            <div className="modal-contactanos modal-response-ficha-background">	            
                <LineamientosPrestamo showModal={() => setShowLineamientos(false)} />
            </div>
        )}
        

        <div>
            <PageWrapper isLoading={isLoading}>
                <PageHeader title="Gestión de Préstamos y Adelantos"/>
                <SearchContainer
                    searchCriteria={searchCriteria}
                    setSearchCriteria={setSearchCriteria}
                    setPaginator={setPaginator}
                    manageSearch={manageSearch}
                    addCleanSearch={handleCleanSearch}>

                    <ButtonsWrapper>
                        {/* El botón "Solicitar aquí" solo debe estar visible para persona con el Rol: 'Gestión de Préstamos y adelantos'*/}
                        
                        <div className="d-flex" style={{ gap: '8px' }}>
                            {rolGestionDePrestamos && !formValues.ExtraData?.EsSoloVisualizador &&
                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={toggleCrearSolicitudPrestamo}>Solicitar aquí</button> 
                            }
                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={() => setShowLineamientos(true)}>Ver lineamientos</button>

                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={handleDownloadExcel}>Descarga Excel</button>

                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={handleDownloadZip}>Descargar Solicitudes ZIP</button>

                            {rolGestionDePrestamos && !formValues.ExtraData?.EsSoloVisualizador && selectedIds.size > 0 && (
                                <button type='button'
                                className='generic-button-buscador'
                                style={{ background: '#28a745', color: '#fff' }}
                                onClick={handleEnviarAPlanillaBatch}>Enviar a Planilla ({selectedIds.size})</button>
                            )}
                        </div>
                        
                    </ButtonsWrapper>
                </SearchContainer>

                <TablePrestamosYAdelantos
                    formValues={formValues}
                    setFormValues={setFormValues}
                    paginator={paginator}
                    setPaginator={setPaginator}
                    keys={INIT_KEYS}
                    fromAdminPage={true}
                    manageSearch={manageSearchProxy}
                    rolGestionDePrestamos={rolGestionDePrestamos}
                    rolLiderEquipo={rolLiderEquipo}
                    rolDirector={rolDirector}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    selectAllRef={selectAllRef}
                >

                </TablePrestamosYAdelantos>

            </PageWrapper>


        </div>
        </>
    )
}

export default GestionPrestamosYAdelantos

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;
